import React from "react"
import BackgroundImage from "gatsby-background-image"

const HeroImage = ({ img, styleClass, title, children }) => {
  return (
    <React.Fragment>
      <BackgroundImage className={styleClass} fluid={img}>
        <div className="container">
          <h1 className=" title text-white text-uppercase text-center display-4">
            {title}
          </h1>
        </div>
      </BackgroundImage>
    </React.Fragment>
  )
}

HeroImage.defaultProps = {
  title: "Welcome to Habitat Hills",
  styleClass: "default-background",
}

export default HeroImage
